const getTruncatedTitles = (products) => {
  const titles = products.map(p => p.title).join(', ');
  return titles.length > 50 ? titles.slice(0, 50) + '...' : titles;
};

export default getTruncatedTitles;